__turbopack_context__.v({
  "arrowImage": "4-module__ag9BwW__arrowImage",
  "carouselContainer": "4-module__ag9BwW__carouselContainer",
  "desktopCarouselSubheading": "4-module__ag9BwW__desktopCarouselSubheading",
  "desktopCarouselTitle": "4-module__ag9BwW__desktopCarouselTitle",
  "headerContainer": "4-module__ag9BwW__headerContainer",
  "heading": "4-module__ag9BwW__heading",
  "sidePanelContainer": "4-module__ag9BwW__sidePanelContainer",
});
